import { render } from "./professionalPhotography.vue?vue&type=template&id=4d680e0f"
import script from "./professionalPhotography.vue?vue&type=script&lang=js"
export * from "./professionalPhotography.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__